import { atomWithStorage } from "jotai/utils";

export const feedAtom = atomWithStorage<any[]>("WOG_feed", []);
export const profileFeedAtom = atomWithStorage<any[]>("WOG_profile_feed", []);
